import React, { useCallback } from 'react';

import { CollapsibleBase, DayFilter } from '@rivallapp/volosports-components';
import toggleArrayItem from '../../../../../zustand-stores/DiscoverStore/utils/toggleArrayItem';
import useDiscoverStore, { DiscoverActions } from '../../../../../zustand-stores/DiscoverStore';
import { useUrlParams } from '../../../../../hooks';

const { updateFilterCollapsed } = DiscoverActions;

const DiscoverDayFilter = () => {
  const { updateUrlParams } = useUrlParams();

  const selectedDaysOfWeek = useDiscoverStore(store => store.filters.selectedDaysOfWeek);
  const selectedDaysOfWeekCollapsed = useDiscoverStore(
    store => store.filtersCollapsed.selectedDaysOfWeek
  );

  const onPressDayOfWeek = useCallback(
    day => {
      updateUrlParams({ daysOfWeek: toggleArrayItem(selectedDaysOfWeek, day) });
    },
    [updateUrlParams, selectedDaysOfWeek]
  );

  const toggleFilterCollapsed = () =>
    updateFilterCollapsed('selectedDaysOfWeek', !selectedDaysOfWeekCollapsed);

  return (
    <CollapsibleBase
      isCollapsed={selectedDaysOfWeekCollapsed}
      title="Day of Week"
      onPress={toggleFilterCollapsed}
    >
      <DayFilter onPress={onPressDayOfWeek} selectedDays={selectedDaysOfWeek} />
    </CollapsibleBase>
  );
};

export default DiscoverDayFilter;
